import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '@sm360/widget-commons-vehicle';
import EmptyGarage from 'commons-garage/components/EmptyGarage/EmptyGarage.jsx';
import LoadedGarage from 'commons-garage/components/LoadedGarage/LoadedGarage.jsx';

const GarageViewTabContent = ({
    isNewEnabled,
    isUsedEnabled,
    usedUrl,
    tradeInAmount,
    tradeInTaxCredits,
    deleteQuote,
    quotes,
    isReservationMode,
}) => {
    const garageWrapper =
        quotes.length > 0 ? (
            <LoadedGarage
                isNewEnabled={isNewEnabled}
                isUsedEnabled={isUsedEnabled}
                usedUrl={usedUrl}
                tradeInAmount={tradeInAmount}
                tradeInTaxCredits={tradeInTaxCredits}
                deleteQuote={deleteQuote}
                quotes={quotes}
                isReservationMode={isReservationMode}
            />
        ) : (
            <div className="empty-garage-wrapper">
                <EmptyGarage isNewEnabled={isNewEnabled} isUsedEnabled={isUsedEnabled} usedUrl={usedUrl} />
            </div>
        );

    return (
        <div className="GarageView-tab-content">
            <div className="GarageView-tab-content-wrapper">{garageWrapper}</div>
        </div>
    );
};

GarageViewTabContent.defaultProps = { quotes: [] };

GarageViewTabContent.propTypes = {
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModelV25)),
    deleteQuote: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    isReservationMode: PropTypes.bool.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    tradeInTaxCredits: PropTypes.number.isRequired,
};

GarageViewTabContent.displayName = 'GarageViewTabContent';

export default GarageViewTabContent;
